// AdminOne ONLY — Mobility Dispatch Page.
import React, { useCallback, useEffect, useState } from "react";
import { SHELL, mobilityApi } from "@/api/connectorPackClient";
import MobilityAdapterStatusGrid from "@/components/mobility/MobilityAdapterStatusGrid";

export default function AdminOneMobilityDispatchPage() {
  const [dispatches, setDispatches] = useState([]);
  const [audit, setAudit] = useState([]);
  const [err,   setErr]   = useState("");
  const load = useCallback(async () => {
    setErr("");
    try {
      const [d, a] = await Promise.all([mobilityApi.dispatches(), mobilityApi.audit()]);
      setDispatches(d.dispatches || []);
      setAudit(a.events || []);
    } catch (e) { setErr(String(e.message || e)); }
  }, []);
  useEffect(() => { load(); }, [load]);
  return (
    <div style={SHELL.page} data-testid="adminone-mobility-page">
      <h2 style={SHELL.h2}>AdminOne · Hardening v1 · Mobility</h2>
      <h1 style={SHELL.h1}>Mobility Dispatch</h1>
      <p style={SHELL.dim}>
        No ride is auto-booked. Healthcare-sensitive workflows require an explicit compliance flag.
      </p>
      {err && <div style={SHELL.err} data-testid="mobility-err">{err}</div>}
      <MobilityAdapterStatusGrid />
      <div style={SHELL.panel}>
        <h2 style={SHELL.h2}>Dispatches · {dispatches.length}</h2>
        <table style={SHELL.table}>
          <thead><tr><th style={SHELL.th}>ID</th><th style={SHELL.th}>Region</th><th style={SHELL.th}>Adapter</th><th style={SHELL.th}>Workflow</th><th style={SHELL.th}>Status</th></tr></thead>
          <tbody>
            {dispatches.map((d) => (
              <tr key={d._id}>
                <td style={SHELL.td}>{d._id.slice(0, 8)}…</td>
                <td style={SHELL.td}>{d.region}</td>
                <td style={SHELL.td}>{d.adapter}</td>
                <td style={SHELL.td}>{d.workflow}</td>
                <td style={SHELL.td}><span style={SHELL.badge()}>{d.status}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div style={SHELL.panel}>
        <h2 style={SHELL.h2}>Audit · {audit.length} event(s)</h2>
        <table style={SHELL.table}>
          <thead><tr><th style={SHELL.th}>Event</th><th style={SHELL.th}>Adapter</th><th style={SHELL.th}>When</th></tr></thead>
          <tbody>
            {audit.map((e) => (
              <tr key={e._id}><td style={SHELL.td}>{e.event_type}</td><td style={SHELL.td}>{e.connector_name}</td><td style={SHELL.td}>{(e.created_at || "").slice(0, 19)}</td></tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
